<div class="container-premium" *ngIf="carInformacionInicial">
  <div class="grid">
    <div class="col-12 text-center">
      <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
      <span>{{ 'LBL_PROCESANDO' | translate }}</span>
    </div>
  </div>
</div>

<div class="container-premium" *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12">
      <h1 class="title-premium">{{ (f.idProductoTroncal.value ? 'PRODUCTOSTRONCAL.LBL_EDITARPRODUCTO' : 'PRODUCTOSTRONCAL.LBL_AGREGARPRODUCTO') | translate | uppercase }}</h1>
    </div>
  </div>

  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate class="productos-troncal-form">
    <div class="grid form-group align-items-start">
      <div class="col-12 md:col-6 lg:col-3">
        <div class="div-form">
          <label>* {{ 'PRODUCTOSTRONCAL.LBL_CODIGO' | translate }}</label>
          <input type="text" pInputText formControlName="codigo" maxlength="6"
                 placeholder="{{ 'LBL_INGRESAR' | translate }}">
          <small class="p-error" *ngIf="submitted && f.codigo.errors?.required">
            {{ 'LBL_REQUERIDO' | translate }}
          </small>
          <small class="p-error" *ngIf="submitted && f.codigo.errors?.codigoDuplicado">
            {{ 'PRODUCTOSTRONCAL.MSG_CODIGODUPLICADOACTIVO' | translate }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-6 lg:col-3">
        <div class="div-form">
          <label>* {{ 'PRODUCTOSTRONCAL.LBL_NOMBRE' | translate }}</label>
          <input type="text" pInputText formControlName="nombre"
                 placeholder="{{ 'LBL_INGRESAR' | translate }}">
          <small class="p-error" *ngIf="submitted && f.nombre.errors?.required">
            {{ 'LBL_REQUERIDO' | translate }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-3 lg:col-3">
        <div class="div-form">
          <label class="campo-label-invisible">&#8203;</label>
          <div class="flex align-items-center gap-2" style="height: 38px;">
            <p-radioButton name="indicadorProducto" [value]="true" formControlName="indicadorProducto"
                           inputId="rProducto" (onClick)="cambiarModo()"></p-radioButton>
            <label for="rProducto" class="cursor-pointer">{{ 'PRODUCTOSTRONCAL.LBL_PRODUCTO' | translate }}</label>
          </div>
        </div>
      </div>

      <div class="col-12 md:col-3 lg:col-3">
        <div class="div-form">
          <label class="campo-label-invisible">&#8203;</label>
          <div class="flex align-items-center gap-2" style="height: 38px;">
            <p-radioButton name="indicadorProducto" [value]="false" formControlName="indicadorProducto"
                           inputId="rTipoProducto" (onClick)="cambiarModo()"></p-radioButton>
            <label for="rTipoProducto" class="cursor-pointer">{{ 'PRODUCTOSTRONCAL.LBL_TIPO' | translate }}</label>
          </div>
        </div>
      </div>
    </div>

    <div class="grid form-group align-items-start">
      <div class="col-12 md:col-6 lg:col-3" *ngIf="!f.indicadorProducto.value">
        <div class="div-form">
          <label>* {{ 'PRODUCTOSTRONCAL.LBL_TIPO' | translate }}</label>
          <p-dropdown [options]="lisTiposProducto" formControlName="idTipoProducto"
                      placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                      optionLabel="label" optionValue="value"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                      [style]="{width:'100%'}"></p-dropdown>
          <small class="p-error" *ngIf="submitted && f.idTipoProducto.errors?.required">
            {{ 'LBL_REQUERIDO' | translate }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-6 lg:col-3">
        <div class="div-form">
          <label>* {{ 'PRODUCTOSTRONCAL.LBL_ICONO' | translate }}</label>
          <p-fileUpload name="file" url="{{svcThUrl}}" [auto]="false" mode="basic"
                        #adjunto
                        (onBeforeUpload)="onBeforeSend($event)"
                        (onValidSelect)="onSelect($event, $event.files)"
                        (onUpload)="onUpload($event)"
                        (onError)="onErrorUpload($event)"
                        accept="image/*"
                        invalidFileTypeMessageSummary="{0} {{'LBL_FILETIPO' | translate}}."
                        invalidFileTypeMessageDetail="{{'ADMINMENUS.LBL_FILETIPOES' | translate}}"
                        fSize
                        chooseIcon="fa fa-paperclip"
                        styleClass="icono-input-simple"
                        chooseLabel="{{ nomArchivoIcono ? nomArchivoIcono : ('LBL_INGRESAR' | translate) }}"></p-fileUpload>
          <small class="p-error" *ngIf="submitted && f.idIcono.errors?.required">
            {{ 'LBL_REQUERIDO' | translate }}
          </small>
          <div *ngIf="imagen" class="flex align-items-center gap-2 mt-2">
            <img [src]="imagen" alt="icono" style="width: 48px; height: 48px; object-fit: contain;">
            <i class="fa fa-times" style="cursor: pointer;" title="{{ 'BTN_ELIMINAR' | translate }}"
               (click)="eliminarIcono()"></i>
          </div>
          <div *ngIf="subiendoAdjunto" class="mt-2">
            <i class="fa fa-refresh fa-spin"></i>
          </div>
        </div>
      </div>

      <div class="col-12 md:col-6 lg:col-3">
        <div class="div-form">
          <label class="campo-label-invisible">&#8203;</label>
          <div class="flex align-items-center gap-2" style="height: 38px;">
            <p-inputSwitch formControlName="indicadorHabilitado" inputId="swHabilitado"></p-inputSwitch>
            <label for="swHabilitado" class="cursor-pointer">{{ 'LBL_HABILITADO' | translate }}</label>
          </div>
        </div>
      </div>
    </div>

    <div class="grid" *ngIf="f.indicadorProducto.value">
      <div class="col-12">
        <app-productos-troncal-productos [(productos)]="productosAgrupados"></app-productos-troncal-productos>
        <small class="p-error" *ngIf="submitted && productosAgrupados.length === 0">
          {{ 'PRODUCTOSTRONCAL.MSG_PRODUCTOREQUERIDO' | translate }}
        </small>
      </div>
    </div>

    <div class="grid form-footer-buttons mt-4">
      <div class="col-12 flex gap-2">
        <button type="button" pButton class="btn-primary-outline" *ngIf="!guardando"
                label="{{ 'BTN_CANCELAR' | translate }}"
                (click)="regresar()"></button>
        <button type="submit" pButton class="btn-primary-full" *ngIf="!guardando"
                icon="fa fa-check-circle"
                [disabled]="subiendoAdjunto"
                label="{{ 'BTN_GUARDAR' | translate }}"></button>
        <div *ngIf="guardando">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
          <span>{{ 'LBL_GUARDANDO' | translate }}</span>
        </div>
      </div>
    </div>
  </form>

  <p-confirmDialog #cd>
    <ng-template pTemplate="footer">
      <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
      <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
    </ng-template>
  </p-confirmDialog>
</div>
